import { useEffect, useState } from 'react';

type NetworkConnection = {
    effectiveType?: 'slow-2g' | '2g' | '3g' | '4g';
    rtt?: number;
    downlink?: number;
    addEventListener: (type: string, listener: EventListener) => void;
    removeEventListener: (type: string, listener: EventListener) => void;
};

function getConnection(): NetworkConnection | undefined {
    return (navigator as Navigator & { connection?: NetworkConnection })
        .connection;
}

const SLOW_NETWORK_TYPES: Array<NetworkConnection['effectiveType']> = [
    'slow-2g',
    '2g',
];

function detectSlowNetwork(): boolean {
    const connection = getConnection();
    if (!connection) return false;

    if (
        connection.effectiveType &&
        SLOW_NETWORK_TYPES.includes(connection.effectiveType)
    ) {
        return true;
    }

    if (connection.rtt !== undefined && connection.rtt > 500) {
        return true;
    }

    if (
        connection.downlink !== undefined &&
        connection.downlink > 0 &&
        connection.downlink < 1
    ) {
        return true;
    }

    return false;
}

export function useSlowNetworkState() {
    const [isSlowNetwork, setIsSlowNetwork] =
        useState<boolean>(detectSlowNetwork);

    useEffect(() => {
        const connection = getConnection();
        if (!connection) return;

        const handleChange = () => {
            setIsSlowNetwork(detectSlowNetwork());
        };

        connection.addEventListener('change', handleChange as EventListener);

        return () => {
            connection.removeEventListener(
                'change',
                handleChange as EventListener,
            );
        };
    }, []);

    return { isSlowNetwork };
}
